import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c608f94"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "personal",
  style: {"margin-top":"10px","border":"none"}
}
const _hoisted_2 = { class: "card-box" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "ant-upload-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = {
  key: 2,
  class: "avatar-uploader-img",
  color: "color:#4084CF;"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { style: {"margin-left":"10px"} }, "点击上传", -1))
const _hoisted_10 = ["src"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "ant-upload-text" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = {
  key: 2,
  class: "avatar-uploader-img",
  color: "color:#4084CF;"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { style: {"margin-left":"10px"} }, "点击上传", -1))
const _hoisted_17 = { class: "personal" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-border-bottom",
  style: {"display":"flex","align-items":"center"}
}, [
  /*#__PURE__*/_createElementVNode("h2", { class: "h2-blue-underline" }, "银行账户信息")
], -1))
const _hoisted_19 = {
  key: 0,
  class: "mark"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 0,
  class: "mark-box"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px","font-size":"18px","color":"#fff"} }, "处理中，请稍等...", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_loading_outlined = _resolveComponent("loading-outlined")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_cloud_upload_outlined = _resolveComponent("cloud-upload-outlined")!
  const _component_exclamation_circle_outlined = _resolveComponent("exclamation-circle-outlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_form, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, {
              style: {"display":"flex","align-items":"baseline"},
              gutter: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  span: 12,
                  style: {"padding-right":"0"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({
                      label: _ctx.t('page.personal.center.compontent.person.name')
                    }, _ctx.validateInfos.nameCn, {
                      labelCol: {span: 8},
                      wrapperCol: {span: 16}
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                          value: _ctx.modelRef.nameCn,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelRef.nameCn) = $event)),
                          placeholder: "请输入与证件名称相符的姓名"
                        }, null, 8, ["disabled", "value"])
                      ]),
                      _: 1
                    }, 16, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({
                      label: _ctx.t('page.personal.center.compontent.person.phone')
                    }, _ctx.validateInfos.phone, {
                      labelCol: {span: 8},
                      wrapperCol: {span: 16}
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_row, { gutter: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, { style: {"margin-bottom":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                                      value: _ctx.modelRef.phone,
                                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelRef.phone) = $event)),
                                      placeholder: "请输入证件人实名注册的大陆手机号码"
                                    }, null, 8, ["disabled", "value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 16, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({
                      label: _ctx.t('page.personal.center.compontent.person.email')
                    }, _ctx.validateInfos.email, {
                      labelCol: {span: 8},
                      wrapperCol: {span: 16}
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          disabled: "",
                          value: _ctx.modelRef.email,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelRef.email) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 16, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({
                      label: _ctx.t('page.personal.center.compontent.person.address')
                    }, _ctx.validateInfos.contactAddress, {
                      labelCol: {span: 8},
                      wrapperCol: {span: 16}
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_cascader, {
                          "change-on-select": "",
                          getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                          disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                          value: _ctx.modelRef.contactAddress,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelRef.contactAddress) = $event)),
                          options: _ctx.arealist,
                          placeholder: _ctx.t('page.personal.center.compontent.person.select')
                        }, null, 8, ["getPopupContainer", "disabled", "value", "options", "placeholder"])
                      ]),
                      _: 1
                    }, 16, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({
                      label: _ctx.t('page.personal.center.compontent.person.addressMod')
                    }, _ctx.validateInfos.detailedAddress, {
                      labelCol: {span: 6},
                      wrapperCol: {span: 16}
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                          value: _ctx.modelRef.detailedAddress,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelRef.detailedAddress) = $event)),
                          placeholder: "请输入正确的详细地址不超过200个字符"
                        }, null, 8, ["disabled", "value"])
                      ]),
                      _: 1
                    }, 16, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({
                      label: _ctx.t('page.personal.center.compontent.person.nationality')
                    }, _ctx.validateInfos.nationality, {
                      labelCol: {span: 8},
                      wrapperCol: {span: 16}
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          allowClear: "",
                          "show-search": "",
                          getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                          "filter-option": _ctx.filterOption,
                          disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                          value: _ctx.modelRef.nationality,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modelRef.nationality) = $event)),
                          onChange: _ctx.handleChange,
                          placeholder: "请选择国籍"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countrylist, (item) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                key: item.id,
                                value: item.name
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["getPopupContainer", "filter-option", "disabled", "value", "onChange"])
                      ]),
                      _: 1
                    }, 16, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({
                      label: _ctx.t('page.personal.center.compontent.person.type')
                    }, _ctx.validateInfos.certificateType, {
                      labelCol: {span: 8},
                      wrapperCol: {span: 16},
                      getPopupContainer: (triggerNode)=>triggerNode.parentNode
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          disabled: "",
                          value: _ctx.modelRef.certificateType,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modelRef.certificateType) = $event)),
                          placeholder: "请选择证件类型"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select_option, { value: 1 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.compontent.person.id')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: 2 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.compontent.person.passport')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_select_option, { value: 3 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.compontent.person.certificateTypes')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }, 16, ["label", "getPopupContainer"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({
                      label: _ctx.t('page.personal.center.compontent.person.number')
                    }, _ctx.validateInfos.certificateNo, {
                      labelCol: {span: 6},
                      wrapperCol: {span: 16}
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                          value: _ctx.modelRef.certificateNo,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modelRef.certificateNo) = $event)),
                          placeholder: "请输入与上传证件相符的证件号码"
                        }, null, 8, ["disabled", "value"])
                      ]),
                      _: 1
                    }, 16, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({
                      style: {"margin-bottom":"0"},
                      label: _ctx.t('page.personal.center.compontent.person.certificateValidity')
                    }, _ctx.validateInfos.effectiveTime, {
                      labelCol: {span: 8},
                      wrapperCol: {span: 16}
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_range_picker, {
                          style: {"width":"100%"},
                          "value-format": "YYYY-MM-DD",
                          getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                          disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                          value: _ctx.modelRef.effectiveTime,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modelRef.effectiveTime) = $event))
                        }, null, 8, ["getPopupContainer", "disabled", "value"])
                      ]),
                      _: 1
                    }, 16, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({
                      label: " ",
                      colon: false
                    }, _ctx.validateInfos.isForever, {
                      labelCol: {span: 1},
                      wrapperCol: {span: 16}
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_checkbox, {
                          disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                          checked: _ctx.modelRef.isForever,
                          "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modelRef.isForever) = $event)),
                          onChange: _ctx.handleChangeForever
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.compontent.person.effective')), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled", "checked", "onChange"])
                      ]),
                      _: 1
                    }, 16)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({
                      label: _ctx.t('page.personal.center.compontent.person.certificate')
                    }, _ctx.validateInfos.certificateAnnex1, {
                      labelCol: {span: 8},
                      wrapperCol: {span: 16}
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_upload, {
                          "list-type": "picture-card",
                          class: "avatar-uploader",
                          "before-upload": _ctx.beforeUpload,
                          "show-upload-list": false,
                          customRequest: _ctx.handleUploadFront,
                          disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                          value: _ctx.modelRef.certificateAnnex1,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modelRef.certificateAnnex1) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_ctx.imageFrontUrl)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "img",
                                  src: _ctx.imageFrontUrl,
                                  alt: "image"
                                }, null, 8, _hoisted_3))
                              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                  (_ctx.loadingF)
                                    ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                                    : (_openBlock(), _createBlock(_component_plus_outlined, { key: 1 })),
                                  _createElementVNode("div", _hoisted_5, [
                                    _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.compontent.person.certificatez')), 1),
                                    _hoisted_6,
                                    _createTextVNode(" " + _toDisplayString(_ctx.t('page.personal.center.compontent.person.size')), 1),
                                    _hoisted_7,
                                    _createTextVNode(" " + _toDisplayString(_ctx.t('page.personal.center.compontent.person.support')) + "：.JPG/.PNG ", 1)
                                  ])
                                ])),
                            (_ctx.certStatus === 2 || _ctx.certStatus === 3)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _createVNode(_component_cloud_upload_outlined, { style: {"color":"#30629C"} }),
                                  _hoisted_9,
                                  _createVNode(_component_a_tooltip, null, {
                                    title: _withCtx(() => [
                                      _createTextVNode("请上传清晰可见的证件照正面文件大小不超过6M文件格式支持:JPG.PNG")
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_exclamation_circle_outlined, { style: {"color":"#30629C","margin-left":"5px"} })
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["before-upload", "customRequest", "disabled", "value"])
                      ]),
                      _: 1
                    }, 16, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({
                      label: _ctx.t('page.personal.center.compontent.person.reverseCertificate')
                    }, _ctx.validateInfos.certificateAnnex2, {
                      labelCol: {span: 6},
                      wrapperCol: {span: 16}
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_upload, {
                          "list-type": "picture-card",
                          class: "avatar-uploader",
                          "before-upload": _ctx.beforeUpload,
                          "show-upload-list": false,
                          customRequest: _ctx.handleUploadOpposite,
                          disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3,
                          value: _ctx.modelRef.certificateAnnex2,
                          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modelRef.certificateAnnex2) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_ctx.imageOppositeUrl)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "img",
                                  src: _ctx.imageOppositeUrl,
                                  alt: "avatar"
                                }, null, 8, _hoisted_10))
                              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  (_ctx.loadingP)
                                    ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                                    : (_openBlock(), _createBlock(_component_plus_outlined, { key: 1 })),
                                  _createElementVNode("div", _hoisted_12, [
                                    _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.compontent.person.upload')), 1),
                                    _hoisted_13,
                                    _createTextVNode(" " + _toDisplayString(_ctx.t('page.personal.center.compontent.person.size')), 1),
                                    _hoisted_14,
                                    _createTextVNode(" " + _toDisplayString(_ctx.t('page.personal.center.compontent.person.support')) + "：.JPG/.PNG ", 1)
                                  ])
                                ])),
                            (_ctx.certStatus === 2 || _ctx.certStatus === 3)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createVNode(_component_cloud_upload_outlined, { style: {"color":"#30629C"} }),
                                  _hoisted_16,
                                  _createVNode(_component_a_tooltip, null, {
                                    title: _withCtx(() => [
                                      _createTextVNode("请上传清晰可见的证件照正面文件大小不超过6M文件格式支持:JPG.PNG")
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_exclamation_circle_outlined, { style: {"color":"#30629C","margin-left":"5px"} })
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["before-upload", "customRequest", "disabled", "value"])
                      ]),
                      _: 1
                    }, 16, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_a_card, null, {
          default: _withCtx(() => [
            _hoisted_18,
            _createVNode(_component_a_row, {
              style: {"margin-top":"15px","display":"flex","align-items":"baseline","padding":"0 1%"},
              gutter: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({
                      label: "银行账号:",
                      labelCol: {span: 6},
                      wrapperCol: {span: 16}
                    }, _ctx.validateInfos.bankId), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          disabled: (_ctx.certStatus === 2 || _ctx.certStatus === 3)&&_ctx.isExitBank,
                          oninput: "value=value.replace(/[^\\d]/g,'')",
                          value: _ctx.modelRef.bankId,
                          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modelRef.bankId) = $event)),
                          placeholder: "请输入银行账号"
                        }, null, 8, ["disabled", "value"])
                      ]),
                      _: 1
                    }, 16)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({
                      label: "开户银行",
                      labelCol: {span: 6},
                      wrapperCol: {span: 16}
                    }, _ctx.validateInfos.bankName), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          disabled: (_ctx.certStatus === 2 || _ctx.certStatus === 3)&&_ctx.isExitBank,
                          value: _ctx.modelRef.bankName,
                          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modelRef.bankName) = $event)),
                          getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                          placeholder: "请选择开户银行",
                          "filter-option": _ctx.filterOption,
                          "show-search": ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banklist, (item) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                key: item.id,
                                value: item.name
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["disabled", "value", "getPopupContainer", "filter-option"])
                      ]),
                      _: 1
                    }, 16)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({
                      label: "开户银行支行:",
                      labelCol: {span: 6},
                      wrapperCol: {span: 16}
                    }, _ctx.validateInfos.subbranchName), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          disabled: (_ctx.certStatus === 2 || _ctx.certStatus === 3)&&_ctx.isExitBank,
                          value: _ctx.modelRef.subbranchName,
                          "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.modelRef.subbranchName) = $event)),
                          placeholder: "请输入开户银行支行"
                        }, null, 8, ["disabled", "value"])
                      ]),
                      _: 1
                    }, 16)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({
                      label: "开户行所在省市",
                      labelCol: {span: 6},
                      wrapperCol: {span: 16}
                    }, _ctx.validateInfos.bankDepositRegion), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_cascader, {
                          allowClear: "",
                          disabled: (_ctx.certStatus === 2 || _ctx.certStatus === 3)&&_ctx.isExitBank,
                          value: _ctx.modelRef.bankDepositRegion,
                          "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.modelRef.bankDepositRegion) = $event)),
                          getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                          options: _ctx.arealist,
                          "show-search": { arealist: _ctx.arealist },
                          placeholder: _ctx.t('page.personal.center.compontent.enterprise.select')
                        }, null, 8, ["disabled", "value", "getPopupContainer", "options", "show-search", "placeholder"])
                      ]),
                      _: 1
                    }, 16)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { style: {"display":"flex","justify-content":"center","padding":"30px 0"} }, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _ctx.handleSubmit,
                      disabled: (_ctx.certStatus === 2 || _ctx.certStatus === 3) && _ctx.isExitBank
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.compontent.person.submit')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"]),
                    _createVNode(_component_a_button, {
                      onClick: _ctx.resetFields,
                      disabled: _ctx.certStatus === 2 || _ctx.certStatus === 3
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('page.personal.center.compontent.person.reset')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"]),
                    (_ctx.certStatus === 2)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          type: "primary",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.fddModal('two')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("认证")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      (_ctx.loadingM)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createVNode(_component_a_spin)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_modal, {
        title: "法大大认证",
        width: "80%",
        visible: _ctx.visible,
        "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.visible) = $event)),
        footer: null,
        maskClosable: false,
        onCancel: _ctx.handleCancel
      }, {
        default: _withCtx(() => [
          _createElementVNode("iframe", {
            src: _ctx.fddurl,
            frameborder: "0",
            class: "iframe"
          }, null, 8, _hoisted_20)
        ]),
        _: 1
      }, 8, ["visible", "onCancel"])
    ]),
    (_ctx.isMark)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(_component_a_spin),
          _hoisted_22
        ]))
      : _createCommentVNode("", true)
  ], 64))
}